/* SSNAV — desktop mega menu interactions (>=990px).
   Hover-intent + click toggle, animated open/close, scroll-close,
   sticky shrink, and keyboard (Enter/Space/Escape) support. */
(function () {
  'use strict';

  var header = document.getElementById('header');
  if (!header) return;

  var triggers = Array.prototype.slice.call(
    header.querySelectorAll('.js-ssnav-trigger')
  );
  if (!triggers.length) return;

  var OPEN_DELAY = 150;
  var CLOSE_DELAY = 180;
  var ANIM_MS = 360;

  var openTimer = null;
  var closeTimer = null;
  var current = null; // panel key currently open

  function panelFor(key) {
    return document.getElementById('ssmega-' + key);
  }
  function triggerFor(key) {
    return header.querySelector('.js-ssnav-trigger[data-mega="' + key + '"]');
  }

  function openMega(key) {
    clearTimeout(closeTimer);
    if (current && current !== key) hidePanel(current);

    var panel = panelFor(key);
    var trig = triggerFor(key);
    if (!panel || !trig) return;

    panel.classList.add('is-open');
    trig.setAttribute('aria-expanded', 'true');
    // double rAF so the display:block paints before the transition
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        panel.classList.add('is-anim');
      });
    });
    current = key;
  }

  function hidePanel(key) {
    var panel = panelFor(key);
    var trig = triggerFor(key);
    if (trig) trig.setAttribute('aria-expanded', 'false');
    if (!panel) return;
    panel.classList.remove('is-anim');
    setTimeout(function () {
      // guard: don't hide if it was reopened mid-animation
      if (!panel.classList.contains('is-anim')) {
        panel.classList.remove('is-open');
      }
    }, ANIM_MS);
  }

  function closeMega() {
    triggers.forEach(function (t) {
      hidePanel(t.getAttribute('data-mega'));
    });
    current = null;
  }

  function scheduleClose() {
    clearTimeout(openTimer);
    closeTimer = setTimeout(closeMega, CLOSE_DELAY);
  }

  function hoverOpen(key) {
    clearTimeout(closeTimer);
    openTimer = setTimeout(function () {
      openMega(key);
    }, OPEN_DELAY);
  }

  triggers.forEach(function (trig) {
    var key = trig.getAttribute('data-mega');

    trig.addEventListener('mouseenter', function () {
      hoverOpen(key);
    });
    // Leaving a trigger only cancels a pending OPEN (so passing over a
    // trigger without stopping won't switch panels). Closing is governed
    // by leaving the whole header, not individual elements.
    trig.addEventListener('mouseleave', function () {
      clearTimeout(openTimer);
    });

    trig.addEventListener('click', function (e) {
      e.preventDefault();
      clearTimeout(openTimer);
      if (current === key) {
        closeMega();
      } else {
        openMega(key);
      }
    });
  });

  // Hover-intent at the header level: as long as the pointer is anywhere
  // inside the header (nav items, the gap below them, or the open panel),
  // keep the menu open. Only schedule a close once it truly leaves the
  // header region. This fixes diagonal travel from a trigger to a button
  // briefly crossing dead space or a sibling nav item.
  header.addEventListener('mouseenter', function () {
    clearTimeout(closeTimer);
  });
  header.addEventListener('mouseleave', function () {
    if (current) scheduleClose();
  });

  // Escape closes and returns focus to the open trigger.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && current) {
      var trig = triggerFor(current);
      closeMega();
      if (trig) trig.focus();
    }
  });

  // Click outside closes.
  document.addEventListener('click', function (e) {
    if (current && !header.contains(e.target)) closeMega();
  });

  // Sticky shrink + close on scroll.
  var ticking = false;
  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        header.classList.toggle('ssnav-scrolled', window.scrollY > 40);
        if (window.scrollY > 40 && current) closeMega();
        ticking = false;
      });
    },
    { passive: true }
  );
})();
